bz_app.directive('infoWindow', [
  '$timeout',
  'propertiesService',
  'markerService',
  'trackPermitMapService',
  'applicationConstants',
  function (
    $timeout,
    propertiesService,
    markerService,
    trackPermitMapService,
    applicationConstants
  ) {
    return {
      restrict: 'A',
      scope: false,
      templateUrl:
        '/assets/properties/directives/info_window.html?v=' +
        applicationConstants.templateVersion,
      link: function (scope, element, attrs) {
        var infoWindow = new google.maps.InfoWindow({})
        var info = function () {
          google.maps.event.addListener(infoWindow, 'domready', function () {
            $('.gm-style-iw')
              .addClass('g6m-style-iw')
              .removeClass('gm-style-iw')
          })
          /* Need to listen to map click to close info window that was left open */
          google.maps.event.addListener(scope.map, 'click', function (event) {
            closeInfoWindow()
          })
        }
        google.maps.event.addDomListener(window, 'load', info())

        scope.$on('pin.clicked', function (event, marker) {
          scope.pin = marker
          if (typeof marker.property !== 'undefined') {
            scope.property = marker.property
            scope.selected = scope.property
          }
          if (!isMobile.check()) {
            if (
              markerService.activeMarker == marker &&
              marker.selected == true
            ) {
              openInfoWindow(marker)
            } else {
              closeInfoWindow()
            }
            trackPermitMapService.clickPin(marker)
          }
        })

        scope.$on('openInfoWindow', function (event, marker) {
          scope.pin = marker
          openInfoWindow(marker)
        })

        scope.$on('zoom-property', function (event, property, skipAPI) {
          if (property.street) {
            var marker = propertiesService.getPinByAddress(property.street)
            scope.pin = marker
            markerService.select(marker)
            scope.selected = property
            property.selected = true
            openInfoWindow(marker)
          }
        })

        scope.format_effective_date = function (date) {
          var date_array = date.split('-')
          var monthNames = [
            'Jan.',
            'Feb.',
            'March',
            'April',
            'May',
            'June',
            'July',
            'Aug.',
            'Sept.',
            'Oct.',
            'Nov.',
            'Dec.',
          ]
          return monthNames[parseInt(date_array[1]) - 1] + ' ' + date_array[0]
        }

        var closeInfoWindow = function () {
          infoWindow.close()
        }

        var openInfoWindow = function (pin) {
          $timeout(setContent, 1)
          infoWindow.open(scope.pin.map, pin)
          $timeout(setContent, 100)
        }

        var setContent = function () {
          infoWindow.setContent(angular.element('.infoBox').html())
          angular
            .element('#info-map-element .property-page-link')
            .click(function () {
              trackPermitMapService.viewPropertyPage('', 'info window')
            })
        }
      },
    }
  },
])
